export const bytesToMegaBytes = bytes => bytes / (1024 ** 2)